import React, { useMemo } from "react";
import { formatRate } from "../utils/number";
import { Button } from "./Button";

export interface Props {
  account: string;
  title: string;
  value: string;
  rate?: number;
  status?: boolean;
  handleStop?: () => void;
  handleStart?: () => void;
  handleDeposit?: () => void;
}

export default function CardInfo({
  account,
  title,
  value,
  status,
  rate,
  handleStop,
  handleStart,
  handleDeposit,
}: Props) {
  const renderButton = useMemo(() => {
    if (handleStop && status) {
      return (
        <Button
          className="w-[80px] rounded-full bg-gradient-to-r from-[#FD7155] to-[#6B94BC] px-3 py-1 text-sm text-white"
          text="Stop"
          onClick={handleStop}
        />
      );
    }
    if (handleStart && !status) {
      return (
        <Button
          className="w-[80px] rounded-full bg-gradient-to-r from-[#FD7155] to-[#6B94BC] px-3 py-1 text-sm text-white"
          text="Run"
          onClick={handleStart}
        />
      );
    }
    if (handleDeposit) {
      return (
        <Button
          className="w-[80px] rounded-full bg-gradient-to-r from-[#FD7155] to-[#6B94BC] px-3 py-1 text-sm text-white"
          text="Deposit"
          onClick={handleDeposit}
        />
      );
    }
    return;
  }, [handleDeposit, handleStart, handleStop, status]);
  return (
    <div className="bg-[#1C1C1C] pt-2 pb-10 px-4 rounded-3xl">
      <div className="flex justify-between">
        <p className="font-bold text-white">{title}</p>
      </div>
      <div className="mt-5 w-full flex justify-center flex-col items-center">
        <p className="text-lg text-white font-light">{value}</p>
        {status && rate && (
          <p className="text-lg text-white font-bold">{formatRate(rate)}</p>
        )}
      </div>
      <div className="mt-5 w-full flex justify-center">{renderButton}</div>
    </div>
  );
}
